module.exports = __webpack_public_path__ + "static/przemek-face-b4dd9309b2467c32649fbe0a071a6dfc.png";